import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

const rubyType = 'crime'
const storeType = 'crimes'

export const PECrimesCardActions = {
  initPeCrimesCard: ({ commit }, index) => {
    commit('setPeCrimesCardLock', { index, lock: true })
  },
  peFetchCrimesCards: async ({ commit, getters }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants`, { params: { type: rubyType } }).
      then(({ data }) => {
        const assistantCards = data?.asylum_assistant
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: assistantCards || [],
        })
      })
  },
  peCrimesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post(`/parties/${party.id}/asylum_assistants`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            crime: section.crime,
            date_of_crime: section.date_of_crime,
            date_of_crime_unknown: section.date_of_crime_unknown,
            date_of_conviction: section.date_of_conviction,
            date_of_conviction_unknown: section.date_of_conviction_unknown,
            aggravated_felony: section.aggravated_felony,
            particularly_serious_crime: section.particularly_serious_crime,
            serious_non_political: section.serious_non_political,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeCrimesCardLock', { index: 'new', lock: true })
        commit('setPeCrimesCardLock', { index: data.id, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peCrimesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/asylum_assistants/${section.id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        commit('setPeCrimesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistant', {
          assistant: storeType,
          value: data,
        })
      }).
      catch(handleError)
  },
  peCrimesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/parties/${party.id}/asylum_assistants/${id}`, {
        asylum_assistant: {
          type: rubyType,
          value: {
            crime: section.crime,
            date_of_crime: section.date_of_crime,
            date_of_crime_unknown: section.date_of_crime_unknown,
            date_of_conviction: section.date_of_conviction,
            date_of_conviction_unknown: section.date_of_conviction_unknown,
            aggravated_felony: section.aggravated_felony,
            particularly_serious_crime: section.particularly_serious_crime,
            serious_non_political: section.serious_non_political,
            narrative: section.narrative,
          },
        },
      }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeCrimesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peCrimesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/parties/${party.id}/asylum_assistants/${id}`, { params: { type: rubyType } }).
      then(({ data }) => {
        const updatedAssistantCards = data?.asylum_assistant

        commit('setPeCrimesCardLock', { index, lock: true })
        commit('pePatchAsylumAssistantList', {
          assistant: storeType,
          list: updatedAssistantCards || [],
        })
      }).
      catch(handleError)
  },
  peCrimesCardAddSection: ({ commit }) => {
    commit('setPeCrimesCardLock', { index: 'new', lock: false })
    commit('addPeCrimesCardSection', {
      id: null,
      crime: '',
      date_of_crime: null,
      date_of_crime_unknown: false,
      date_of_conviction: null,
      date_of_conviction_unknown: false,
      aggravated_felony: false,
      particularly_serious_crime: false,
      serious_non_political: false,
      narrative: '',
    })
  },
  peCrimesCardDownloadPDF: async ({ getters }, { legalCaseId }) => {
    const party = getters.peParty

    return await axiosRequest.
      post(`/parties/${party.id}/asylum_assistant_download`, { asylum_assistant: { legal_case_id: legalCaseId } }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const PECrimesCardMutations = {
  setPeCrimesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.CrimesCard) Vue.set(state.partyEdit.partySections, 'CrimesCard', {})
    Vue.set(state.partyEdit.partySections.CrimesCard, index, lock)
  },
  addPeCrimesCardSection: (state, section) => state.partyEdit.asylumAssystant[storeType].push(section),
  peCrimesCardCreateUndo: state => {
    state.partyEdit.asylumAssystant[storeType].pop()
    Vue.set(state.partyEdit.partySections.CrimesCard, 'new', true)
  },
}

export const PECrimesCardGetters = {
  peCrimesCardLock: state => index => state.partyEdit.partySections.CrimesCard[index],
  peCrimesCardHasNewSection: state => !!state.partyEdit.asylumAssystant[storeType]?.find(crime => crime.id === null),
}
